// Prevent duplicate declaration
if (typeof DiscountPopup === 'undefined') {
  window.DiscountPopup = class DiscountPopup {
    constructor() {
        this.overlay = document.getElementById('discount-popup-overlay');
        this.trigger = document.querySelector('.discount-popup-trigger');
        this.dataTriggers = document.querySelectorAll('[data-popup-trigger]');
        this.closeBtn = document.querySelector('.discount-popup__close');
        this.form = document.getElementById('discount-form');
        this.floatingButton = document.querySelector('.floating-discount-button');
        
        this.init();
    }
    
    init() {
        // Event listeners for class-based trigger
        if (this.trigger) {
            this.trigger.addEventListener('click', (e) => {
                e.preventDefault();
                this.openPopup();
            });
        }
        
        // Event listeners for data-popup-trigger elements
        this.dataTriggers.forEach(trigger => {
            trigger.addEventListener('click', (e) => {
                e.preventDefault();
                
                // If clicking the floating button, hide it first
                if (trigger.classList.contains('floating-discount-button')) {
                    this.hideFloatingButton();
                    this.openPopup(true); // Pass true to indicate opened by floating button
                } 
                // If clicking the footer button, also hide floating button
                else if (trigger.classList.contains('discount-popup-trigger')) {
                    this.hideFloatingButton();
                    this.openPopup(false); // Pass false for footer trigger
                } 
                // If clicking the discount banner button, also hide floating button
                else if (trigger.classList.contains('discount-banner--title-button')) {
                    this.hideFloatingButton();
                    this.openPopup(false); // Pass false for banner trigger
                } 
                else {
                    this.openPopup(false); // Pass false for other triggers
                }
            });
        });
        
        if (this.closeBtn) {
            this.closeBtn.addEventListener('click', () => {
                this.closePopup();
            });
        }
        
        // Close on overlay click
        if (this.overlay) {
            this.overlay.addEventListener('click', (e) => {
                if (e.target === this.overlay) {
                    this.closePopup();
                }
            });
        }
        
        // Close on Escape key
        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && this.isOpen()) {
                this.closePopup();
            }
        });
        
        // Handle form submission
        if (this.form) {
            this.form.addEventListener('submit', (e) => {
                this.handleFormSubmit(e);
            });
        }
        
        // Check if popup should be shown (e.g., first visit)
        this.checkPopupDisplay();
        
        // Hide floating button initially
        this.hideFloatingButton();
    }
    
    openPopup(openedByFloatingButton = false) {
        if (this.overlay) {
            this.overlay.classList.add('active');
            document.body.style.overflow = 'hidden'; // Prevent background scrolling
            this.overlay.style.display = 'flex';
            
            // Store if opened by floating button
            this.openedByFloatingButton = openedByFloatingButton;
            
            // Focus on email input
            const emailInput = this.overlay.querySelector('.discount-email-input');
            if (emailInput) {
                setTimeout(() => emailInput.focus(), 100);
            }
        }
    }
    
    closePopup() {
        if (this.overlay) {
            this.overlay.classList.remove('active');
            document.body.style.overflow = ''; // Restore scrolling
            
            // Add closing animation
            setTimeout(() => {
                this.overlay.style.display = 'none';
                
                // Always show floating button when popup is closed
                this.showFloatingButton();
                
                // Reset the flag
                this.openedByFloatingButton = false;
            }, 300);
        }
    }
    
    isOpen() {
        return this.overlay && this.overlay.classList.contains('active');
    }
    
    handleFormSubmit(e) {
        e.preventDefault();
        
        const formData = new FormData(this.form);
        const email = formData.get('contact[email]');
        
        if (!email) {
            this.showError('Please enter your email address');
            return;
        }
        
        if (!this.isValidEmail(email)) {
            this.showError('Please enter a valid email address');
            return;
        }
        
        // Show loading state
        const submitBtn = this.form.querySelector('.discount-submit-btn');
        const originalText = submitBtn.textContent;
        submitBtn.textContent = 'Subscribing...';
        submitBtn.disabled = true;
        
        // Submit form
        fetch('/contact#contact_form', {
            method: 'POST',
            body: formData
        })
        .then(response => {
            if (response.ok) {
                this.showSuccess();
                // Close popup and show floating button if it was opened by floating button
                this.closePopup();
            } else {
                throw new Error('Subscription failed');
            }
        })
        .catch(error => {
            console.error('Error:', error);
            this.showError('Something went wrong. Please try again.');
        })
        .finally(() => {
            // Reset button
            submitBtn.textContent = originalText;
            submitBtn.disabled = false;
        });
    }
    
    isValidEmail(email) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    }
    
    showError(message) {
        this.showMessage(message, 'error');
    }
    
    showSuccess() {
        this.showMessage('Thank you for subscribing! Check your email for confirmation.', 'success');
    }
    
    showMessage(message, type) {
        // Remove existing messages
        const existingMessage = this.overlay.querySelector('.discount-message');
        if (existingMessage) {
            existingMessage.remove();
        }
        
        // Create new message
        const messageDiv = document.createElement('div');
        messageDiv.className = `discount-message discount-message--${type}`;
        messageDiv.textContent = message;
        
        // Insert after form
        this.form.parentNode.insertBefore(messageDiv, this.form.nextSibling);
        
        // Auto remove after 5 seconds
        setTimeout(() => {
            if (messageDiv.parentNode) {
                messageDiv.remove();
            }
        }, 5000);
    }
    
    checkPopupDisplay() {
        // Check if popup should auto-show
        const autoShow = this.overlay.dataset.autoShow;
        const autoShowDelay = this.overlay.dataset.autoShowDelay || 3;
        
        if (autoShow === 'true') {
            // Check if popup was already shown in this session
            const popupShown = sessionStorage.getItem('discount-popup-shown');
            
            if (!popupShown) {
                // Show popup after specified delay
                setTimeout(() => {
                    this.openPopup();
                    sessionStorage.setItem('discount-popup-shown', 'true');
                }, autoShowDelay * 1000);
            }
        }
    }
    
    hideFloatingButton() {
        if (this.floatingButton) {
            // Remove visible class to trigger slide down animation
            this.floatingButton.classList.remove('visible');
            
            // Hide completely after animation
            setTimeout(() => {
                this.floatingButton.style.display = 'none';
            }, 500); // Match CSS transition duration
        }
    }
    
    showFloatingButton() {
        if (this.floatingButton) {
            // Show the button first
            this.floatingButton.style.display = 'flex';
            
            // Add visible class to trigger slide up animation
            setTimeout(() => {
                this.floatingButton.classList.add('visible');
            }, 50); // Small delay to ensure display is set
        }
    }
  };
}

// Initialize when DOM is loaded (only once)
if (!window.discountPopupInitialized) {
    document.addEventListener('DOMContentLoaded', () => {
        try {
            if (window.DiscountPopup) {
                new window.DiscountPopup();
                window.discountPopupInitialized = true;
            }
        } catch (error) {
            console.error('Error initializing DiscountPopup:', error);
        }
    });
}